import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategoryTabs from './components/CategoryTabs';
import FeaturedMovies from './components/FeaturedMovies';
import LatestUpdates from './components/LatestUpdates';
import StatsBanner from './components/StatsBanner';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <CategoryTabs />
        <FeaturedMovies />
        <StatsBanner />
        <LatestUpdates />
      </main>
      <Footer />
    </>
  );
}